/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespPriceNegotiationToast_displayInfo$ref = any;
export type PdpRespPriceNegotiationToastLoader_displayInfo$ref = any;
export type PdpRespPriceNegotiationToastLoader_displayInfo = {
    readonly " $fragmentRefs": PdpRespPriceNegotiationToast_displayInfo$ref;
    readonly " $refType": PdpRespPriceNegotiationToastLoader_displayInfo$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespPriceNegotiationToastLoader_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespPriceNegotiationToast_displayInfo",
      "args": null
    }
  ]
};
(node as any).hash = '310aaa24029eb4f1c7fae8f368b456ef';
export default node;
